import React from "react";

/**
 * Composant pour afficher une information en lecture seule avec badge ou texte
 */
const ProfileInfoCard = ({ label, value, type = "text" }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "Jamais utilisé";
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const renderValue = () => {
    switch (type) {
      case "badge":
        return (
          <span className="inline-block px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
            {value || "N/A"}
          </span>
        );
      case "credits":
        return (
          <p className="text-2xl font-bold text-blue-600">
            {value || 0} crédits
          </p>
        );
      case "count":
        return (
          <p className="text-gray-800 py-2">
            {value || 0} enfant(s)
          </p>
        );
      case "date":
        return (
          <p className="text-gray-800 py-2">
            {formatDate(value)}
          </p>
        );
      default:
        return (
          <p className="text-gray-800 py-2">
            {value || "-"}
          </p>
        );
    }
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      {renderValue()}
    </div>
  );
};

export default ProfileInfoCard;
